import React, { useEffect, useState } from 'react';
import { Balloon, Calendar, Loading } from '@alifd/next';
import moment from 'moment';
import { Servlets } from '@/service/index';
import utils from '@/common/utils';
import styles from './index.module.scss';


const { Tooltip } = Balloon;
const currentDate = moment();
moment.locale('zh-cn');
// 失败活动的状态码
const error = ['4', '5', '102', '199'];
const errorStr = {
  4: '驳回',
  5: '投放终止',
  102: '投放失败',
  199: '后台投放失败',
};
// const successStr = {
//   '1':'审核中',
//   '3':'审核通过',
//   '100':'投放中',
//   '99':'后台投放中',
//   '101':'投放成功'
// }

const successStr = {
  0: '未执行',
  1: '执行中',
  2: '执行成功',
  3: '执行失败',
  4: '手动停止',
};
// 月日历展示节日
const holidays = [
  {
    20: '年货节开始',
  }, {
    3: '立春',
    4: '小年',
    11: '除夕',
    12: '春节',
    14: '情人节',
    18: '年货节结束',
    26: '元宵节',
  }, {
    8: '女神节',
  }, {
    1: '愚人节',
    4: '清明节',
  }, {
    1: '劳动节',
    4: '青年节',
    5: '立夏',
    9: '母亲节',
    20: '电商大促',
    21: '电商大促',
  }, {
    1: '儿童节',
    14: '端午节',
    18: '电商大促',
    20: '父亲节',
  }, {
    1: '建党节',
  }, {
    1: '建军节',
    7: '立秋',
    14: '七夕',
    18: '电商大促818',
    22: '中元节',
  }, {
    10: '教师节',
    21: '中秋节',
  }, {
    1: '国庆节',
    14: '重阳节',
    20: '11.11预售开启',
    31: '11.11开门红',
  }, {
    7: '立冬',
    10: '11.11爆发',
    11: '电商大促11.11',
    12: '11.11返场',
    25: '感恩节',
    30: '12.12预售开启',
  }, {
    11: '12.12爆发',
    12: '电商大促12.12',
    13: '12.12返场',
    24: '平安夜',
    25: '圣诞节',
  },
];

const HCalendar = ({ type, startTime, endTime }) => {
  const [loadingVisible, setLoadingVisible] = useState(false);
  // 月 数据
  const [trendData, setTrendData] = useState([]);
  // 周数据
  const [weekTrendData, setWeekTrendData] = useState([]);
  const [weekList, setWeekList] = useState([]);


  // 获取活动详情接口
  const getCanlendar = () => {
    Servlets('getSmsCalendar', {
      startTime: moment().startOf('month').valueOf(),
      endTime: moment().endOf('month').valueOf(),
    }).then((res) => {
      setLoadingVisible(false);
      const { data } = res;
      // 数据处理
      if (type === 'month') {
        const result = [];
        if (data) {
          data.forEach((item) => {
            const date = moment(item.time).format('YYYY-MM-DD').substring(8);
            const dayData = result.filter((dayData) => dayData.date === date)[0];
            if (dayData) {
              dayData.data.push(item);
            } else {
              result.push({
                date,
                data: [item],
                eventList: {
                  success: [],
                  error: [],
                },
              });
            }
          });
          result.forEach((day) => {
            day.data.forEach((item) => {
              if (error.indexOf(item.packStatue) >= 0) {
                day.eventList.error.push({ name: item.name, status: item.packStatue });
              } else {
                day.eventList.success.push({ name: item.name, status: item.packStatue });
              }
            });
            day.date = Number(day.date);
          });
          setTrendData(result);
        }
      } else {
        const tableList = [
          {
            key: '09',
            value: ['09:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '10',
            value: ['10:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '11',
            value: ['11:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '12',
            value: ['12:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '13',
            value: ['13:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '14',
            value: ['14:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '15',
            value: ['15:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '16',
            value: ['16:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '17',
            value: ['17:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '18',
            value: ['18:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '19',
            value: ['19:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
          {
            key: '20',
            value: ['20:00', { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }, { acArray: [] }],
          },
        ];
        data.forEach((item) => {
          item.key = item.sendTime.substring(11, 13);
          item.index = utils.getWeek(item.time).num + 1;
        });
        tableList.forEach((item) => {
          data.forEach((obj) => {
            if (item.key === obj.key) {
              item.value[obj.index].flag = false;
              item.value[obj.index].acArray.push(obj);
            }
          });
        });
        setWeekTrendData(tableList);
      }
    });
  };

  // 生成周数组
  const getWeekArray = () => {
    const array = [];
    for (let i = 0; i < 7; i++) {
      array.push({ week: utils.getWeek(getWeek(i)).week, date: getWeek(i).substring(5) });
    }
    setWeekList(array);
    // console.log(333,utils.getWeek('2020/09/19'));
    // const today = utils.getWeek('2020/09/19')
    // const resourse =
    // // date.valueOf()
    // console.log(22333, new Date().toLocaleDateString().split('/').join('-'));
  };

  // 获取当周指定第几天日期
  function getWeek(i) {
    const now = new Date();

    const firstDay = new Date(now - (now.getDay() - 1) * 86400000);

    firstDay.setDate(firstDay.getDate() + i - 1);

    const mon = Number(firstDay.getMonth()) + 1;

    return `${now.getFullYear() }/${ mon }/${ firstDay.getDate()}`;
  }

  // 打开下拉框事件
  const openDetail = ({ findex, sindex }) => {
    const newData = utils.deepObj(weekTrendData);
    newData[findex].value[sindex].flag = !newData[findex].value[sindex].flag;
    setWeekTrendData(newData);
  };
  const WeekChildren = ({ children, findex, sindex }) => {
    const newArray = children.acArray;
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <div style={{ padding: '0.5px 2px 0.5px 2px' }}>
          {newArray.length ?
            <div
              className={`${error.indexOf(newArray[0].packStatue) > 0 ? styles.activityErr : styles.activitySuc} ${styles.payNumDemo}`}
            >
              <span style={{ marginRight: 5 }}>{newArray[0].sendTime.substring(11, 16)}</span>
              <span>{`${newArray[0].name}`}</span>
            </div> : null
          }
          {newArray.length > 1 &&
          <div
            className={`${styles.orangeChildren} ${styles.row_between}`}
            onClick={() => openDetail({ findex, sindex })}
          >
            <div>
              <span style={{ marginRight: 5 }}>{`+${newArray.length - 1}`}</span>more
            </div>
            <div className={'iconfont icon-icon-12'} style={{ fontSize: 12 }} />
          </div>
          }
        </div>
        {children.flag &&
        <div className={`${styles.dropDown}`} onClick={() => openDetail({ findex, sindex })}>
          <div className={styles.row_between}>
            <div>{newArray[0].time.substring(5)} {utils.getWeek(newArray[0].time).week}</div>
            <div className={'iconfont icon-icon-13'} style={{ fontSize: 12 }} />
          </div>
          <div>
            {newArray.map((obj) =>
              (<div
                style={{ marginTop: 1 }}
                className={`${error.indexOf(obj.packStatue) > 0 ? styles.activityErr : styles.activitySuc} ${styles.payNumDemo}`}
              >{`${obj.sendTime.substring(11, 16)} ${obj.name}`}
               </div>))}
          </div>
        </div>
        }
      </div>
    );
  };
  // 周
  const WeekTable = () => {
    return (
      <section>
        <div className={styles.tableHead}>
          <div className={`${styles.headCell} ${styles.cellText}`} style={{ width: '5.1%' }}><span>时段</span>
          </div>
          {weekList.map((item) =>
            (<div key={utils.key()} className={styles.headCell}>
              <div className={styles.cellText}><span>{item.week}</span></div>
              <div style={{ marginTop: 2 }}><span>{item.date}</span></div>
             </div>))}
        </div>
        <div key={utils.key()} className={styles.tableBox}>
          {weekTrendData.map((item, findex) =>
            (<div key={utils.key()} className={styles.tableRow}>
              {item.value.map((children, sindex) =>
                (sindex === 0 ?
                  <div
                    key={utils.key()}
                    className={`${styles.tableCell} ${styles.cellLeft}`}
                  >{children}
                  </div> :
                  <div key={utils.key()} className={`${styles.tableCell} ${styles.cellRight}`}>
                    <WeekChildren findex={findex} sindex={sindex} children={children} />
                  </div>))}
             </div>))}
        </div>
      </section>
    );
  };
  // 月
  const dateCellRender = (date) => {
    const dateNum = date.date();
    if (currentDate.month() !== date.month()) {
      return dateNum;
    }
    let eventList;
    // 判断该日有没有活动
    trendData.forEach((item) => {
      if (dateNum === item.date) {
        eventList = item.eventList;
      }
    });

    return (
      <div style={{ marginTop: 3, width: '100%' }}>
        {holidays[currentDate.month()].hasOwnProperty(dateNum) ?
          <div><span>{dateNum}</span><span
            style={{ marginLeft: 5 }}
          >{holidays[currentDate.month()][dateNum]}
          </span>
          </div> :
          dateNum === new Date().getDate() ?
            <div><span>{dateNum}</span><span style={{ marginLeft: 5 }}>今天</span></div> :
            <div>{dateNum}</div>
        }
        {eventList &&
        <div className="caTooltip">
          {eventList.success.length ?
            <Balloon
              delay={10}
              align="b"
              closable={false}
              popupClassName={styles.calendarTooltip}
              trigger={<div className={styles.successEvent}>
                <span>正常活动</span><span>{`+${eventList.success.length}`}</span>
                       </div>}
            >
              <div className={styles['tooltip-content']}>
                {eventList.success.map((item) =>
                  (<div key={utils.key()} className={styles.tooltipBox}><span
                    style={{ marginRight: 10 }}
                  >{item.name}
                                                                        </span><span>{successStr[item.status]}</span>
                   </div>))}
              </div>
            </Balloon> : null
          }
          {eventList.error.length ?
            <Balloon
              delay={10}
              align="b"
              closable={false}
              popupClassName={styles.calendarTooltip}
              trigger={<div className={styles.errorEvent}>
                <span>失败活动</span><span>{eventList.error.length > 1 && `+${eventList.error.length}`}</span>
                       </div>}
            >
              <div className={styles['tooltip-content']}>
                <div className={styles['tooltip-content']}>
                  {eventList.error.map((item) =>
                    (<div key={utils.key()} className={styles.tooltipBox}><span
                      style={{ marginRight: 10 }}
                    >{item.name}
                                                                          </span><span>{errorStr[item.status]}</span>
                     </div>))}
                </div>
              </div>
            </Balloon> : null
          }
        </div>
        }
      </div>
    );
  };
  useEffect(() => {
    // setLoadingVisible(true)
    getCanlendar();// 日历活动
    // getWeekArray()
    // console.log(startTime,endTime);
  }, [startTime, endTime, type]);
  useEffect(() => {
    // document.getElementsByClassName('lz-cjyx-calendar-cell').forEach((e) => {
    //   e.setAttribute('title', '');
    // });
  }, [dateCellRender]);
  // useEffect(() => {
  //   WeekTable()
  // }, [trendData]);

  return (
    <section className={`${styles.pageBox} marginB-20`}>
      <Loading visible={loadingVisible}>
        {type === 'month' &&
        <div style={{ marginTop: 10 }}>
          <Calendar shape="fullscreen" dateCellRender={dateCellRender} />
        </div>
        }
        {type === 'week' &&
        <div>
          <WeekTable />
        </div>
        }
      </Loading>
    </section>
  );
};
export default HCalendar;
